module.exports = __webpack_public_path__ + "html/bd-row.template.html";